import { defaultInitialState, loadingState, updatedState, getErrorState } from '../utils';
import { EMAIL_UPDATE, EMAIL_UPDATE_DONE, EMAIL_UPDATE_ERR, CONFIRM_EMAIL_CHANGE, CONFIRM_EMAIL_UPDATE_DONE, CONFIRM_EMAIL_UPDATE_ERR, EMAIL_UPDATE_RESET } from './actionTypes';
const initialState = defaultInitialState;
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case EMAIL_UPDATE:
            return Object.assign(Object.assign({}, state), loadingState);
        case EMAIL_UPDATE_DONE:
            return Object.assign(Object.assign({}, state), updatedState);
        case EMAIL_UPDATE_ERR:
            return Object.assign(Object.assign({}, state), getErrorState(action.data.msg));
        case CONFIRM_EMAIL_CHANGE:
            return Object.assign(Object.assign(Object.assign({}, state), { data: null }), loadingState);
        case CONFIRM_EMAIL_UPDATE_DONE:
            return Object.assign(Object.assign(Object.assign({}, state), { data: true }), updatedState);
        case CONFIRM_EMAIL_UPDATE_ERR:
            return Object.assign(Object.assign(Object.assign({}, state), { data: null }), getErrorState(action.data.msg));
        case EMAIL_UPDATE_RESET:
            return defaultInitialState;
        default:
            return state;
    }
};
export default reducer;
//# sourceMappingURL=reducer.js.map